export default __webpack_public_path__ + "static/media/map.b71cc10b.svg";